import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MainPage.css';

const MainPage = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/app');
  };

  return (
    <div className="main-page-container">
      <div className="overlay"></div>
      <div className="content">
        {/* Top Text Section */}
        <div className="top-text">
          <h1 className="main-title">Welcome to Code Mentor</h1>
          <p className="main-subtitle">Enhance your coding journey with interactive learning.</p>
        </div>

        {/* Text Section */}
        <div className="section">
          <div className="center-column">
            <h2>Learn with Ease</h2>
            <p>Our platform offers guided mentorship to help you master coding skills efficiently.</p>
          </div>
        </div>

        {/* Career Boost Section */}
        <div className="section">
          <div className="text-box">
            <h2>Boost Your Career</h2>
            <p>Enhance your portfolio with real-world coding projects and guidance from experts.</p>
          </div>
          <div className="text-box">
            <p>Our platform provides personalized mentorship to help you achieve your career goals.</p>
          </div>
        </div>

        {/* Call-to-Action Section */}
        <div className="section">
          <p className="mini-subtitle">Get Feedback From Your Personal AI</p>
          <button onClick={handleButtonClick}>Talk to Code Mentor</button>
        </div>
      </div>
    </div>
  );
};

export default MainPage;